/**
 * Lightweight safety-net formatter for tenant names.
 *
 * Adds a space after commas that aren't followed by one —
 * handles stale DB records that haven't been through the
 * backend normalization yet.
 *
 * Title-case logic lives on the backend only;
 * the frontend just fixes comma spacing for display.
 */
export function formatTenantName(name: string | null | undefined): string {
  if (name === null || name === undefined || name === '') return 'Unnamed Tenant';
  return name.replace(/,(?!\s)/g, ', ').trim();
}
